<template>
    <div>
        <div class="top-bar">
            <div class="cwrap">
                <ul class="topbar-links">
                    <!--<li>您好！欢迎来到新版账户中心 V{{this.currentMainVersion}}{{ this.currentEnv !== this.envMapper.prod ? '_t' + this.currentTestVersion : '' }}</li>-->
                   <!-- <li>您好！欢迎来到新版账户中心 V{{this.currentMainVersion}}{{ this.currentEnv !== this.envMapper.prod ? '_t' + this.currentTestVersion : '' }}</li>-->
                    <li>您好！欢迎来到新版账户中心</li>
                    <template v-if="!isLogin">
                        <li style="padding: 0 13px"><a href="/accountcenter/login.html">【登录】</a></li>
                        <!-- <li style="padding: 0 13px"><a href="/accountcenter/register/account.html">【免费注册】</a></li> -->
                        <!-- <li><a href="/accountcenter/register/account.html">基金开户</a></li> -->
                    </template>
                    <template v-else>
                        <li v-if="userData.regStep == 0"><a href="/">{{userData.first_name}}{{userData.sex == 1 ? '先生':'女士'}}</a></li>
                        <li v-if="isLogin"><a @click="logout">退出</a></li>
                    </template>
                    <li><a href="http://www.win-stock.com.cn/product/soft/benefits.html">软件购买</a></li>
                </ul>
            </div>
        </div>
        <div class="header bxsh">
            <div class="cwrap">
                <div class="logo">
                    <a href="javascript:;" @click="backIndex"><img src="/accountcenter/static/images/logo.png" alt=""></a>
                </div>
                <ul class="navigation">
                    <!-- <li><a href="/accountcenter/index.html">账户首页</a></li>
                    <li><a href="/accountcenter/deal/buy.html">基金交易</a></li>
                    <li><a href="/accountcenter/account/query.html">账户服务</a></li>
                    <li><a href="/accountcenter/settings/cards.html">账户设置</a></li> -->
<!--                   &lt;!&ndash; <li><a href="/coupon.html">券中心</a></li>&ndash;&gt;-->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import packageJson from '../../package';

    var envMapper = {
        prod: 'production',
        test: 'test',
        dev: 'development'
    };

    export default {
        name: 'top',
        data () {
            return {
                isLogin: false,
                userData: {},
                envMapper,
                currentEnv: '',
                currentMainVersion: '',
                currentTestVersion: ''
            }
        },
        mounted () {
            this.init();
            this._checkingVersion();
            if(!sessionStorage.getItem('access_token')){
                this.isLogin = false
            }else{
                this.isLogin = true
                if(!sessionStorage.getItem('userData')){
                    this.getUserinfo()
                }else{
                    this.userData = JSON.parse(sessionStorage.getItem('userData'))
                }
            }
        },
        methods: {
            init: function(){
                var idx = ''
                this.pathname = window.location.pathname;
                if(this.pathname.indexOf('/deal/') != -1){
                    idx = 1
                }
                if(this.pathname.indexOf('/account/') != -1){
                    idx = 2
                }
                if(this.pathname.indexOf('/settings/') != -1){
                    idx = 3
                }
                $('.navigation').find('li').eq(idx).addClass('active')
            },
            _checkingVersion: function () {
                var { version, testVersion } = packageJson;
                var { NODE_ENV, type } = process.env;
                if (NODE_ENV === 'development') {
                    this.currentEnv = this.envMapper.dev;
                } else if (NODE_ENV === 'production') {
                    if (type === 'uat') {
                        this.currentEnv = this.envMapper.test;
                    } else if (type === 'pdt') {
                        this.currentEnv = this.envMapper.prod;
                    }
                }

                this.currentMainVersion = version;
                this.currentTestVersion = testVersion;
            },
            logout(){
                this.$confirm('确定退出登录吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function(){
                    $.ajax({
                        type: 'POST',
                        url: platformUrl + 'api/1.0.0/oauth/logout',
                        data: {
                            access_token: sessionStorage.getItem('access_token')
                        },
                        dataType: 'json',
                        success: function(res){
                                sessionStorage.setItem('access_token', '')
                                sessionStorage.setItem('refresh_token', '')
                                sessionStorage.setItem('username', '')
                                sessionStorage.setItem('userData', '')
                                window.name = ""
                                window.location.href = '/accountcenter/login.html'
                        },
                        error: function(res){
                            sessionStorage.setItem('access_token', '')
                            sessionStorage.setItem('refresh_token', '')
                            sessionStorage.setItem('username', '')
                            sessionStorage.setItem('userData', '')
                            window.name = ""
                            window.location.href = '/accountcenter/login.html'
                        }
                    });
                }).catch(function(){});
            },
            getUserinfo: function(){
                var that = this;
                this.post('ufx/acct/info', {username: sessionStorage.getItem('username')}, {
                    success: function(res){
                        that.userData = res
                        sessionStorage.setItem('userData', JSON.stringify(res));
                    }
                })
            },
            backIndex: function() {
                window.location.href = window.backIndexUrl;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/top.vue